export default "__VITE_ASSET__BboJ7EBc__"